import script from "./index.vue?vue&type=script&setup=true&lang=ts"
export * from "./index.vue?vue&type=script&setup=true&lang=ts"

import "./index.scss?vue&type=style&index=0&id=fb1f51b0&scoped=true&lang=scss"

import exportComponent from "/Users/agnisvegners/Projects/anatomynext/hpc-new/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fb1f51b0"]])

export default __exports__